
import React from 'react';
import { CardContent } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import SignInForm from '@/components/auth/SignInForm';
import SignUpForm from '@/components/auth/SignUpForm';

interface AuthContentTabsProps {
  handleSignIn: (email: string, password: string) => Promise<void>;
  handleSignUp: (email: string, password: string, username: string) => Promise<void>;
  handleForgotPassword: (email: string) => Promise<void>;
  loading: boolean;
  defaultTab?: string;
}

/**
 * Component that handles the tabs for sign in and sign up
 */
const AuthContentTabs: React.FC<AuthContentTabsProps> = ({
  handleSignIn,
  handleSignUp,
  handleForgotPassword,
  loading,
  defaultTab = 'signin'
}) => {
  return (
    <CardContent>
      <Tabs defaultValue={defaultTab} className="w-full">
        <TabsList className="grid w-full grid-cols-2 mb-4">
          <TabsTrigger value="signin">Sign In</TabsTrigger>
          <TabsTrigger value="signup">Sign Up</TabsTrigger>
        </TabsList>
        
        <TabsContent value="signin">
          <SignInForm
            onSubmit={handleSignIn}
            loading={loading}
            onForgotPassword={handleForgotPassword}
          />
        </TabsContent>
        
        <TabsContent value="signup">
          <SignUpForm
            onSubmit={handleSignUp}
            loading={loading}
          />
        </TabsContent>
      </Tabs>
    </CardContent>
  );
};

export default AuthContentTabs;
